export const APP_SHELL_FLAG_KEY = 'ap_rebrand_app_shell_ia'
export const UI_THEME_FLAG_KEY = 'ap_rebrand_ui_theme'
